import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid, Checkbox } from '@mui/material';
import { Typography } from '@totalsoft/rocket-ui';
import WrappedLinearProgress from 'components/common/WrappedLinearProgress';

export const OfferFinancialServicesHeaderItemComponent = ({
  t,
  onChange,
  financialServicesWrite,
  category,
  servicesLoading,
  currencyCode,
  idx,
  readOnlyFull
}) => {
  const handleServiceSelectionChange = useCallback(
    event => {
      onChange(null, category.serviceCategoryId, event);
    },
    [category, onChange]
  );

  return (
    <>
      <Grid container spacing={1} alignItems='center'>
        <Grid item xs={6} sm={1}>
          <Checkbox
            id={'offerFinancialServicesCard_itemCard_' + idx + '_header_categoryIsSelected'}
            checked={category.isSelected}
            onChange={handleServiceSelectionChange}
            disabled={
              readOnlyFull ||
              category.isMandatory ||
              !financialServicesWrite ||
              (servicesLoading &&
                servicesLoading.some(x => category.services.find(y => y.serviceTypeId === x.serviceTypeId) && x.value === true))
            }
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Typography
            variant='caption'
            fontWeight='bold'
            fontSize='18px'
            color='primary'
            id={'offerFinancialServicesCard_itemCard_' + idx + '_header_categoryName'}
          >
            {' '}
            {category.name} :{' '}
          </Typography>
          {servicesLoading &&
          servicesLoading.some(x => category.services.find(y => y.serviceTypeId === x.serviceTypeId) && x.value === true) ? (
            <Grid item xs={2} md={1}>
              <WrappedLinearProgress />
            </Grid>
          ) : (
            <Typography
              variant='caption'
              fontWeight='bold'
              fontSize='18px'
              color='primary'
              id={'offerFinancialServicesCard_itemCard_' + idx + '_header_categoryMonthlyValue'}
            >
              {' '}
              {t('DECIMAL2', { number: category.serviceMonthlyAmount })} {currencyCode} / {t('OfferEdit.FinancialServices.Month')}
            </Typography>
          )}
        </Grid>
      </Grid>
    </>
  );
};

OfferFinancialServicesHeaderItemComponent.propTypes = {
  t: PropTypes.func.isRequired,
  servicesLoading: PropTypes.array.isRequired,
  category: PropTypes.object,
  currencyCode: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  financialServicesWrite: PropTypes.bool,
  idx: PropTypes.number.isRequired,
  readOnlyFull: PropTypes.bool.isRequired
};

export default withTranslation()(memo(OfferFinancialServicesHeaderItemComponent));
